export default __webpack_public_path__ + "static/media/account_avatar.e2cd5f45.jpeg";